import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const regionApi_URL =
  'http://getsubregions-adminisn-server-ovtlplnimx.cn-beijing.fcapp.run';

export const regionApi = createApi({
  reducerPath: 'regionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: regionApi_URL
  }),
  endpoints: (builder) => ({
    getSubRegions: builder.query({
      query: (regionCode, includeGeometry) => {
        return {
          url: 'getSubRegions',
          params: {
            region_code: regionCode ? regionCode : 'WORLD',
            include_geometry: includeGeometry
          }
        };
      }
    }),
    getGeometry: builder.query({
      queryFn: async (regionCode, _queryApi, _extraOptions, fetchWithBQ) => {
        // return null directly with no regionCode input
        if (regionCode === null) {
          return { data: null };
        }
        try {
          const result = await fetchWithBQ({
            url: 'getGeometry',
            params: {
              region_code: regionCode
            }
          });
          return { data: result.data };
        } catch (error) {
          return { error: { status: error.status, data: error.data } };
        }
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubRegionsQuery, useGetGeometryQuery } = regionApi;
